var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61963 29.2144H11.2533V40.9752C11.2533 42.2547 10.2161 43.292 8.93649 43.292V43.292C7.65692 43.292 6.61963 42.2547 6.61963 40.9752V29.2144Z",
    fill: "#0059B2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 27.3169,
    width: 4.63372,
    height: 50,
    rx: 2.31686,
    transform: "rotate(-90 0 27.3169)",
    fill: "#0059B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7466 29.2144H43.3803V40.9752C43.3803 42.2547 42.343 43.292 41.0634 43.292V43.292C39.7839 43.292 38.7466 42.2547 38.7466 40.9752V29.2144Z",
    fill: "#0059B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5835 29.2144H36.0548V42.0564C36.0548 42.7388 35.5016 43.292 34.8192 43.292V43.292C34.1367 43.292 33.5835 42.7388 33.5835 42.0564V29.2144Z",
    fill: "#0059B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5483 29.2144H15.6666V42.2329C15.6666 42.8178 15.1924 43.292 14.6075 43.292V43.292C14.0225 43.292 13.5483 42.8178 13.5483 42.2329V29.2144Z",
    fill: "#0059B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.978 29.2144H29.6117V40.9752C29.6117 42.2547 28.5744 43.292 27.2949 43.292V43.292C26.0153 43.292 24.978 42.2547 24.978 40.9752V29.2144Z",
    fill: "#0059B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0054 29.2144H22.6391V40.9752C22.6391 42.2547 21.6018 43.292 20.3222 43.292V43.292C19.0427 43.292 18.0054 42.2547 18.0054 40.9752V29.2144Z",
    fill: "#0059B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61963 9.02487C6.61963 7.7453 7.65692 6.70801 8.93649 6.70801V6.70801C10.2161 6.70801 11.2533 7.7453 11.2533 9.02486V20.7857H6.61963V9.02487Z",
    fill: "#0059B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7466 9.02487C38.7466 7.7453 39.7839 6.70801 41.0634 6.70801V6.70801C42.343 6.70801 43.3803 7.7453 43.3803 9.02486V20.7857H38.7466V9.02487Z",
    fill: "#0059B2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5835 7.94367C33.5835 7.26123 34.1367 6.70801 34.8192 6.70801V6.70801C35.5016 6.70801 36.0548 7.26123 36.0548 7.94366V20.7857H33.5835V7.94367Z",
    fill: "#0059B2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5483 7.76714C13.5483 7.1822 14.0225 6.70801 14.6075 6.70801V6.70801C15.1924 6.70801 15.6666 7.1822 15.6666 7.76714V20.7857H13.5483V7.76714Z",
    fill: "#0059B2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.978 9.02487C24.978 7.7453 26.0153 6.70801 27.2949 6.70801V6.70801C28.5744 6.70801 29.6117 7.7453 29.6117 9.02486V20.7857H24.978V9.02487Z",
    fill: "#0059B2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0054 9.02487C18.0054 7.7453 19.0427 6.70801 20.3222 6.70801V6.70801C21.6018 6.70801 22.6391 7.7453 22.6391 9.02486V20.7857H18.0054V9.02487Z",
    fill: "#0059B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelPrimary);
export default __webpack_public_path__ + "static/media/label_primary.5c3eae807d4a3e037dac2232a6579604.svg";
export { ForwardRef as ReactComponent };